module.exports = __webpack_public_path__ + "img/fenxibaogao.47574350.png";